import BaseService from '_services/rest/base';
import { getDateISO } from '_utils';

class LeadService extends BaseService {
  constructor() {
    super();
  }

  getUrl() {
    return `${super.getUrl()}/api/lead`;
  }

  getFilters(params) {
    return {
      search: params.search,
      region: params.region,
      state: params.state,
      initialDate: getDateISO(params.date_from),
      endDate: getDateISO(params.date_to),
    };
  }

  getList(params) {
    const filters = this.getFilters(params);

    return this.request(`${this.getUrl()}/all/${params.skip}/${params.take}`, filters)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  getLeadById(id) {
    return this.request(`${this.getUrl()}/${id}`)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  download(params) {
    const filters = this.getFilters(params);

    return this.request(`${this.getUrl()}/download`, filters, 'get')
      .catch(err => {
        throw err;
      });
  }

  toggleSpam(id, status) {
    return this.request(`${this.getUrl()}/${id}/spam`, { status }, 'PATCH')
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }
}

export default new LeadService();
